export default "__VITE_ASSET__DXfMdTzW__"